import { RootState } from '@/core/redux/store';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MenuHeader from '../menuHeader';
import { getData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { setActiveCustomerTab, setHeader, setIsLoggedIn, setUserDetails } from '@/core/redux/commonSlice';
import { removeCartItem } from '@/core/redux/cartSlice';
import { Link, useNavigate } from 'react-router';
import { routePrefix, routes } from '@/utils/routes/routes';
import { MdClose, MdDelete, MdPersonAdd, MdSearch } from 'react-icons/md';
import { toast } from 'react-toastify';
import { TbHeart, TbMapPin, TbShoppingCart } from 'react-icons/tb';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { emptycart, headerLogo } from '@/utils/imagepath';
import Offcanvas from "react-bootstrap/Offcanvas";
import Modal from "react-bootstrap/Modal";

const Header1 = ({ themeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);

  const [sticky, setSticky] = useState('');
  const fixedheader = `home-one-header header ${sticky}`;
  const headerData = useSelector((state: RootState) => state.common.header);
  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);
  const [visibleRight, setVisibleRight] = useState(false);
  const cartItems = useSelector((state: RootState) => state.cart.cartItems);
  const formRef = useRef<HTMLFormElement>(null);
  const [value, setValue] = useState<string>('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  const navigate = useNavigate();

  const dataCount = useSelector(
    (state: RootState) => state.common.wishListCount
  );

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const [showSearchCanvas, setShowSearchCanvas] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const formRef2 = useRef(null);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? 'fixed' : '';
    setSticky(stickyClass);
  };
  const dispatch = useDispatch();

  const getHeader = async () => {
    try {
      const response = await getData(end_points.headers.url);
      dispatch(setHeader(response?.data?.data));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getHeader();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  }, []);

  const handleCheckout = () => {
    if (isLoggedIn) {
      if (cartItems?.length == 0) {
        toast.warn('Please add some products to your cart');
      } else {
        setVisibleRight(false);
        navigate(routes.checkout);
      }
    } else {
      toast.warn('Please login to Checkout');
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(async () => {
      if (inputValue.trim() !== '') {
        navigate(`${routePrefix}/search/${inputValue}`);
        setShowSearchCanvas(false);
      }
    }, 1000);

    setSearchTimeout(timeout);
  };

  var sidebar = document.getElementById("sidebar");
  var overlay = document.getElementById("overlay");

  const sidebarOpen = () => {
    sidebar?.classList.add("active");
    overlay?.classList.add("active");
  };

  const sidebarClose = () => {
    sidebar?.classList.remove("active");
    overlay?.classList.remove("active");
  };

  return (
    <>
      <header
        className={fixedheader}
        style={{
          background: `#${editData?.theme_1?.home?.header?.nav?.nav_bg_color}`,
        }}
      >
        <div className="header-top">
          <div className="container">
            <div className="row header-nav">
              <div className="col-md-auto col-sm-12">
                <div className="logo">
                  <span id="sidebarCollapse" className="d-block d-md-none" onClick={sidebarOpen}>
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUBAMAAACKWYuOAAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt0UjBAAAACnRSTlMAn+kJaXHfOan2+lReqgAAAD9JREFUGNNjwAsYlWCgAchjWwUDCUAeeygMFDCQBIxhAMRhEYQBByCPE27DBFQ5VH0kAXYXGCjA8AMHkv9QAQD7KiJgja6M9QAAAABJRU5ErkJggg=="
                      className="img-fluid"
                      alt=""
                    />
                  </span>
                  <a href="/" className="">
                    <img
                      id="site_logo"
                      src={headerData?.logo}
                      alt=""
                    />
                  </a>
                  <span className="mob-user hidden-md dropdown d-block d-md-none">
                    <a
                      className="more-items"
                      data-bs-toggle="dropdown"
                      href="#"
                    />
                    <ul
                      role="menu"
                      className="dropdown-menu"
                      aria-labelledby="drop1"
                    >
                      {!isLoggedIn && (
                        <li>
                          <Link to={routes.login}>Login</Link>
                        </li>
                      )}
                    </ul>
                  </span>
                </div>
              </div>
              <div className="col-md col-sm-12">
                <div className="d-none d-md-flex align-items-center h-100">
                  <ul className="header-link">
                    {headerData.headers.map((header: any) => (
                      <li className="menu-hover" key={header.id}>
                        <Link
                          to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                        >
                          {header?.title}
                        </Link>
                      </li>
                    ))}
                    {headerData?.table_management_enabled === '1' && (
                      <li>
                        <Link to={routes.tableBooking}>Request a Table</Link>
                      </li>
                    )}
                    <li>
                      <Link to={routes.pricing}>Pricing</Link>
                    </li>
                  </ul>
                  <ul className="header-link-right">
                    {/* Search moved near track order */}
                    {/* <li className="d-none d-xl-inline-block">
                      <a href={`tel:${editData?.theme_1?.home?.header?.nav.contact?.number}`} className="">
                        <i className="me-2 uil uil-phone-volume" />
                        <span style={{ color: 'rgb(46, 54, 57)' }}>
                          {editData?.theme_1?.home?.header?.nav.contact?.number}
                        </span>
                      </a>
                    </li>   */}
                    {/* <li
                      className="header-box"
                      style={{ background: 'rgb(255, 255, 255)' }}
                    >
                      <img
                        className="cart-icon p-1"
                        src="/static/media/cart.233ba650fc499169faeacc618c1bf370.svg"
                        alt=""
                        style={{ background: 'rgb(240, 127, 27)' }}
                      />
                      <span style={{ color: 'rgb(0, 0, 0)' }}>£0.00</span>
                      <span
                        id="cart_total_count"
                        className="count-blk"
                        style={{
                          color: 'rgb(0, 0, 0)',
                          background: 'rgb(240, 127, 27)',
                        }}
                      >
                        0
                      </span>
                    </li>
                    <li
                      className="header-auth header-box"
                      style={{
                        border: '2px solid rgb(27, 157, 179)',
                        background: 'rgb(255, 255, 255)',
                      }}
                    >
                      <a
                        href="/login"
                        className=""
                        style={{ color: 'rgb(27, 157, 179)' }}
                      >
                        <img
                          src="/static/media/log-user.2996aab472c88b8dc6f5e3c9695cffd0.svg"
                          alt=""
                        />
                        Login / Register
                      </a>
                    </li> */}
                    {!isLoggedIn ? (
                      <li>
                        <Link to={routes.login}><i className='ti ti-user-circle'></i></Link>
                      </li>
                    ) : (
                      <li className="user-menu position-relative">
                        <i className='ti ti-user-circle'></i>
                        <ul className="user-dropdown-menu">
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('account-details'));
                              }}
                            >
                              My Account
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('orders'));
                              }}
                            >
                              Order History
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('address'));
                              }}
                            >
                              Addresses
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={''}
                              onClick={() => {
                                localStorage.clear();
                                dispatch(setUserDetails({}));
                                dispatch(setIsLoggedIn(false));
                                navigate(routes.login);
                              }}
                            >
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}
                    <li>
                      <button 
                        className="border-0 bg-transparent p-0" 
                        onClick={() => setShowSearchCanvas(true)}
                        title="Search"
                      >
                        <i className='ti ti-search'></i>
                      </button>
                    </li>
                    <li>
                      <Link
                        to={isLoggedIn ? routes.trackOrder : routes.login}
                        onClick={() =>
                          !isLoggedIn && toast.warning('Please Login to Tract Order')
                        }
                        title="Track Order"
                      >
                        <i className='ti ti-map-pin'></i>
                      </Link>
                    </li>
                    <li className="cart__menu position-relative">
                      <Link
                        to={isLoggedIn ? routes.customerDashboard : routes.login}
                        onClick={() => {
                          if (isLoggedIn) {
                            dispatch(setActiveCustomerTab('wishlist'));
                          } else {
                            toast.warning('Please Login to Wishlist');
                            navigate(routes.login);
                          }
                        }}
                        title="Wishlist"
                      >
                        <i className='ti ti-heart' />
                      </Link>
      
                      <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                        {isLoggedIn ? dataCount : 0}
                      </span>
                    </li>
                    <li className="cart__menu position-relative">
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => {
                          setVisibleRight(true);
                        }}
                      >
                        {/* <button type='button'></button> */}
                        <i className='ti ti-basket' />
                        <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                          {cartItems?.length}
                        </span>
                      </button>
                    </li>
                  </ul>
                  <Sidebar
                    visible={visibleRight}
                    position="right"
                    onHide={() => setVisibleRight(false)}
                    showCloseIcon={false}
                    className="custom-sidebar"
                  >
                    {/* Header */}
                    <div className="cart-header">
                      <div className="cart-title">My Cart</div>
                      <Button
                        icon={<MdClose size={20} />}
                        className="p-button-text p-button-rounded p-button-danger cart-close-btn"
                        onClick={() => setVisibleRight(false)}
                      />
                    </div>

                    {/* Content */}
                    {cartItems?.length > 0 ? (
                      <div className="cart-content">
                        {cartItems.map((item, index) => (
                          <div key={index} className="cart-item">
                            <div className="cart-item-details">
                              <div className="cart-description">
                                <div className="cart-image">
                                  <img
                                    src={item?.image}
                                    alt={item?.name}
                                    className="img-fluid"
                                  />
                                </div>
                                <div className="cart-info-details">
                                  <div className="cart-title">
                                    <p>{item?.name}</p>
                                  </div>
                                  <div className="quantity">
                                    <p>
                                      <span className="text-muted">
                                        {item.variant === 'express' && `(${item.variant}) `}
                                      </span>
                                      {item?.quantity} x {item?.price}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="cart-remove">
                                <button
                                  onClick={() => dispatch(removeCartItem(item?.id))}
                                >
                                  <MdDelete size={20} color="red" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="empty-cart-content">
                        <img
                          src={emptycart}
                          alt="Empty Cart"
                          className="empty-cart-image"
                        />
                        <p className="empty-cart-text">
                          Your cart is currently empty
                        </p>
                        <Link to={routes?.home} className="shop-now-btn">
                          Shop Now
                        </Link>
                      </div>
                    )}

                    {/* Footer */}
                    <div className="cart-footer">
                      <span>Subtotal:</span>
                      <span className="subtotal-amount">{total.toFixed(2)}</span>
                    </div>
                    <div className="cart-footer-btns d-flex ">
                      <Link
                        to={routes.cart}
                        className="btn btn-primary w-100 m-2"
                        onClick={() => setVisibleRight(false)}
                      >
                        View Cart
                      </Link>
                      <button
                        className="btn btn-secondary w-100 m-2"
                        onClick={handleCheckout}
                      >
                        Checkout
                      </button>
                    </div>
                  </Sidebar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <MenuHeader /> */}
      <Modal
        show={showSearchCanvas}
        onHide={() => setShowSearchCanvas(false)}
        size="lg"
        className="search-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center">Search Products</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form
            ref={formRef}
            onSubmit={(e) => {
              e.preventDefault();
              if (value.trim() !== '') {
                if (searchTimeout) clearTimeout(searchTimeout);
                navigate(`${routePrefix}/search/${value}`);
                setShowSearchCanvas(false);
              }
            }}
          >
            <div className="input-group">
              <input
                id="search"
                type="text"
                placeholder="Search products..."
                name="search"
                className="form-control"
                value={value}
                onChange={handleSearch}
                style={{ height: '50px' }}
              />
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center"
                type="submit"
                style={{
                  width: '60px',
                  backgroundColor: '#007bff',
                  borderTopRightRadius: '4px',
                  borderBottomRightRadius: '4px',
                }}
              >
                <MdSearch size={24} />
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div
          id="mCSB_1"
          className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
          style={{ maxHeight: "480px" }}
        >
          <div
            id="mCSB_1_container"
            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            style={{ position: "relative", top: "0px", left: "0px" }}
            dir="ltr"
          >
            <div id="dismiss" onClick={sidebarClose}>
              <i className="fa fa-arrow-left"></i>
            </div>
            <div className="sidebar-header"></div>
            <ul className="list-unstyled components">
              {headerData.headers.map((header: any) => (
                <li key={header.id}>
                  <Link
                    to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                  >
                    {header?.title}
                  </Link>
                </li>
              ))}
              {headerData?.table_management_enabled === 1 && (
                <li>
                  <Link to={routes.tableBooking}>Table Booking</Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div
          id="mCSB_1_scrollbar_vertical"
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical"
          style={{ display: "none" }}
        >
          <div className="mCSB_draggerContainer">
            <div
              id="mCSB_1_dragger_vertical"
              className="mCSB_dragger"
              style={{
                position: "absolute",
                minHeight: "0px",
                height: "0px",
                top: "0px",
                display: "block",
              }}
            >
              <div
                className="mCSB_dragger_bar"
                style={{ lineHeight: "0px" }}
              ></div>
            </div>
            <div className="mCSB_draggerRail"></div>
          </div>
        </div>
      </nav>
      <div id="overlay" onClick={sidebarClose}></div>
    </>
  );
};

export default Header1;
